const name = 'openapi.yaml'
const text = `openapi: 3.1.0
info:
  title: API
  version: 1.0.0
paths:
  /endpoint:
    get:
      responses:
        '200':
          description: OK
`
const template = { name, text }
export default template
